import { Box } from '@material-ui/core'
import { Controller } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { FormattedText, FormControl, Icon, PhoneNumberField, Typography } from 'src/modules/core/components'
import type { ConfigurationFormPhoneNumbersProps } from './configuration-form-phone-numbers.interface'
import classes from './configuration-form.module.scss'

export function ConfigurationFormPhoneNumbers({
  control,
  fields,
  errors,
  defaultCountryCode,
  noPhoneNumbersError,
  canAddMore,
  onAdd,
  onRemove,
}: ConfigurationFormPhoneNumbersProps) {
  const { formatMessage } = useIntl()
  const label = formatMessage({ id: 'configuration.step1.personalMode.phone.label' })

  function errorFor(index: number) {
    return errors.phoneNumbers?.[index]?.phone?.message || noPhoneNumbersError
  }

  return (
    <Box marginBottom={3}>
      {fields.map((phone, index) => (
        <Box marginBottom={1} key={phone.id}>
          <FormControl labelClassName={classes.label} label={`${label} ${index + 1}`} error={errorFor(index)}>
            <Controller
              control={control}
              name={`phoneNumbers.${index}`}
              defaultValue={phone}
              render={(props) => (
                <Box display="flex" alignItems="center" gridColumnGap={10}>
                  <PhoneNumberField
                    value={phone.phone}
                    defaultCountry={defaultCountryCode}
                    error={errorFor(index)}
                    onChange={(value: string, countryCode: string | null) => {
                      props.field.onChange({
                        country: countryCode,
                        phone: `+${value.replace(/\D/g, '')}`,
                      })
                    }}
                  />
                  {index > 0 && (
                    <span onClick={() => onRemove(index)}>
                      <Icon name="close" className={classes.removeButton} />
                    </span>
                  )}
                </Box>
              )}
            />
          </FormControl>
        </Box>
      ))}
      {canAddMore && (
        <Typography variant="body" className={classes.textButton} onClick={onAdd}>
          + <FormattedText id="configuration.step1.personalMode.addPhone" />
        </Typography>
      )}
    </Box>
  )
}
